import { http } from '../../axios';

export async function sendPageTitleAndDescription(to) {
  await new Promise(r => setTimeout(r, 1000));

  const title = document.head.querySelector('title')?.text;
  const description = document.head.querySelector('meta[name=description]')?.content;

  await http.post('/api/prerender/set', {
    path: to.fullPath,
    title,
    description,
  });
}
